import { replaceJyotishaTopicInUrl, setQuizAssessInUrl } from './jyotishaTopicUrl';
import { saveLastJyotishaTopic } from './jyotishaHomeHub';

/**
 * Navigate to Jyotisha and open a topic (used from site home, topic cloud, etc.).
 * @param {(pageId: string) => void} onPageChange
 * @param {string} topicId
 * @param {string | null} [searchQuery]
 * @param {{ assess?: boolean }} [options]
 */
export function navigateToJyotishaTopic(onPageChange, topicId, searchQuery = null, options = {}) {
  if (!topicId) return;
  saveLastJyotishaTopic(topicId);
  replaceJyotishaTopicInUrl(topicId);
  if (topicId === 'quiz-daily') setQuizAssessInUrl(Boolean(options.assess));
  else setQuizAssessInUrl(false);
  onPageChange('jyotisha');
  const q = typeof searchQuery === 'string' ? searchQuery.trim() : '';
  window.setTimeout(() => {
    window.dispatchEvent(
      new CustomEvent('jyotisha-open-topic', {
        detail: { topicId, searchQuery: q.length >= 2 ? q : null, assess: Boolean(options.assess) },
      }),
    );
  }, 80);
}

/**
 * @param {(pageId: string) => void} onPageChange
 * @param {string} groupId
 */
export function navigateToJyotishaMilestone(onPageChange, groupId) {
  onPageChange('jyotisha');
  window.setTimeout(() => {
    window.dispatchEvent(new CustomEvent('jyotisha-open-milestone', { detail: { groupId } }));
  }, 80);
}
